var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifyTeacher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "verify"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/verify"
  }, /*#__PURE__*/React.createElement("g", {
    id: "verify_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.56 10.7401L20.2 9.16006C19.94 8.86006 19.73 8.30006 19.73 7.90006V6.20006C19.73 5.14006 18.86 4.27006 17.8 4.27006H16.1C15.71 4.27006 15.14 4.06006 14.84 3.80006L13.26 2.44006C12.57 1.85006 11.44 1.85006 10.74 2.44006L9.17 3.81006C8.87 4.06006 8.3 4.27006 7.91 4.27006H6.18C5.12 4.27006 4.25 5.14006 4.25 6.20006V7.91006C4.25 8.30006 4.04 8.86006 3.79 9.16006L2.44 10.7501C1.86 11.4401 1.86 12.5601 2.44 13.2501L3.79 14.8401C4.04 15.1401 4.25 15.7001 4.25 16.0901V17.8001C4.25 18.8601 5.12 19.7301 6.18 19.7301H7.91C8.3 19.7301 8.87 19.9401 9.17 20.2001L10.75 21.5601C11.44 22.1501 12.57 22.1501 13.27 21.5601L14.85 20.2001C15.15 19.9401 15.71 19.7301 16.11 19.7301H17.81C18.87 19.7301 19.74 18.8601 19.74 17.8001V16.1001C19.74 15.7101 19.95 15.1401 20.21 14.8401L21.57 13.2601C22.15 12.5701 22.15 11.4301 21.56 10.7401ZM16.16 10.1101L11.33 14.9401C11.19 15.0801 11 15.1601 10.8 15.1601C10.6 15.1601 10.41 15.0801 10.27 14.9401L7.85 12.5201C7.56 12.2301 7.56 11.7501 7.85 11.4601C8.14 11.1701 8.62 11.1701 8.91 11.4601L10.8 13.3501L15.1 9.05006C15.39 8.76006 15.87 8.76006 16.16 9.05006C16.45 9.34006 16.45 9.82006 16.16 10.1101Z",
    fill: "#0066F2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyTeacher);
export default __webpack_public_path__ + "static/media/verify-teacher.3828ed61eab0bded39e8c0ea2a9a944a.svg";
export { ForwardRef as ReactComponent };